export default "__VITE_ASSET__faTKU8aB__"